<template>
  <a-modal
    :title="`${modalTit}：${comDatas.comname}`"
    :visible.sync="isLimitDialogShow"
    :width="isEnglish ? '516px' : '486px'"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    class="edit-limit-dialog"
    :mask-closable="false"
    :confirm-loading="confirmLoading"
    @ok="submitHandle"
    @cancel="isLimitDialogShow=false"
  >
    <div class="creat-dilog-form">
      <a-form
        ref="editForm"
        :form="form"
        :hide-required-mark="true"
        class="demo-form-inline"
      >
        <a-form-item
          :label="`${createrTit}：`"
          :label-col="{ span: isEnglish ? 7: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          {{ baseinfoData.truename }}
        </a-form-item>
        <a-form-item
          :label="`${mobileTit}：`"
          :label-col="{ span: isEnglish ? 7: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input
            v-decorator="['mobile', { rules: [
              { required: true, message: '', trigger: 'blur' }
            ] ,initialValue: mobile}]"
            :disabled="true"
            class="valid-m"
          />
        </a-form-item>
        <!-- <captcha-input
          :label="imgValidTit"
          :label-col="{ span: isEnglish ? 7: 5 }"
          :wrapper-col="{ span: 16 }"
        /> -->
        <a-form-item
          :label="`${validTit}：`"
          prop="checkcode"
          :label-col="{ span: isEnglish ? 7: 5 }"
          :wrapper-col="{ span: 16 }"
          class="password-box"
        >
          <a-input
            v-decorator="decorators.checkcode"
            type="text"
            :placeholder="validPlaceholder"
          />
          <get-code
            class="find-pwd-link ml-16"
            :is-disabled="isDisabled"
            type="13"
            :mobile="baseinfoData.mobile"
            @getRes="getRes"
          />
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>
<script>

import GetCode from '@/components/pc/GetCode.vue'
import { mapActions, mapState } from 'vuex'
import { getLang } from '@/lib/storage'
// import CaptchaInput from '@/components/pc/CaptchaInput.vue'

export default {
  components: {
    GetCode
  },
  props: {
    comDatas: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      isDisabled: false,
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false
    }
  },
  computed: {
    ...mapState('organization/org', ['decorators', 'baseinfoData']),
    mobile () {
      let str = this.baseinfoData.mobile
      if (str) {
        let str2 = str.substring(0, 3) + '****' + str.substring(7, 11)
        return str2
      } else {
        return str
      }
    },
    createrTit () {
      return this.$t('message["130"]')
    },
    validPlaceholder () {
      return this.$t('message["824"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["915"]')
    },
    mobileTit () {
      return this.$t('message["1112"]')
    },
    validTit () {
      return this.$t('message["1433"]')
    },
    imgValidTit () {
      return '图片验证码'
    },
    modalTit () {
      return this.$t('message["1644"]')
    },
    isEnglish () {
      return this.getLang() === 'en'
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  mounted () {
  },
  methods: {
    ...mapActions('organization/org', ['ajaxFirstTranOrg']),
    getLang,
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    submitHandle (formName) {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const formDatas = Object.assign(values, { cid: this.comDatas.cid, mobile: this.baseinfoData.mobile })
          const chain = await this.ajaxFirstTranOrg({ cid: this.comDatas.cid })
          chain.params(formDatas)
            .onSuccess(() => {
              this.isLimitDialogShow = false
              this.$emit('tiggerTransfer')
            })
            .config({ tip: false })
            .setForm(this.form)
            .fetch()
          // this.isLimitDialogShow = false
        }
      })
    },
    getRes (payload) {
      // this.inviteLogin.checkuserid = payload.checkuserid
    }
  }
}
</script>
<style lang="scss" scoped>
  .dismiss-org-tip {
    margin: 0 10px 24px 30px;
    color: #333;
  }
  .password-box::v-deep {
    position: relative;

    .find-pwd-link {
        right: 0;
        top: -7px;
        position: absolute;

      button {
        background: none;
        border: 0;
        color: #5077aa;
        padding: 0;
      }

      .is-disabled {
        color: #c0c4df;
        background: none;
      }
      em {
        margin-right: 12px;
      }
    }
  }
</style>
